import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authors-section',
  templateUrl: './authors-section.component.html',
  styleUrls: ['./authors-section.component.scss']
})
export class AuthorsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
